import Vue from 'vue'
import { axios } from '../util/request'

/**
 * 修改密码。
 * @param {*} parameter
 */
export function changePassword(parameter) {
	return axios({
		url: '/sys/user/updatePassword',
		method: 'PUT',
		data: parameter,
	})
}

/**
 * 获取工厂用户。
 * @param {*} factory
 */
export function getFactoryUsers(factory) {
	return axios({
		url: '/sys/user/factory?factory=' + factory,
		method: 'GET',
	})
}

/**
 * 获取所有角色。
 */
export function getAllRoles() {
	return axios({
		url: '/sys/role/queryAllRoles',
		method: 'GET',
	})
}
